import React from "react";

const AboutGDesk = ({ firstcontent, seccontent, thirdcontent }) => {
  return (
    <div className="py-4 px-2 mx-2 lg:mx-10 flex justify-content-center align-content-center flex-col">
      <p className="text-black text-sm lg:text-base py-3 lg:py-2 text-center lg:text-left">{firstcontent}</p>
      <p className="text-black text-sm lg:text-base py-3 lg:py-2 text-center lg:text-left">{seccontent}</p>
      <p className="text-black text-sm lg:text-base py-3 lg:py-2 text-center lg:text-left">{thirdcontent}</p>
    </div>
  );
};

export default AboutGDesk;
